import { Button } from '@app/components';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import { useTypedNavigate } from '@app/router';
import { Routes } from '@app/constants/routes';
import { ButtonProps } from '@app/components/buttons/button/Button';

export const CreateQRCodeButton: React.FC<ButtonProps> = ({ onClick, endIcon, ...otherProps }) => {
  const { t } = useTranslation();

  const navigate = useTypedNavigate();

  const handleCerateQRCodeClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(e);
    navigate({ to: Routes.customer.create_qr_code });
  };

  return (
    <a href={Routes.customer.create_qr_code} onClick={(e) => e.preventDefault()}>
      <Button {...otherProps} onClick={handleCerateQRCodeClick} startIcon={!endIcon ? <AddIcon /> : endIcon}>
        {t('myQRCodes.createQRCode')}
      </Button>
    </a>
  );
};
